export default __webpack_public_path__ + "static/media/image-linegraph.e052d9bf.jpg";